import { Text } from "@chakra-ui/react";
import { NumericFormat } from "react-number-format";

interface NumberProps {
    value: number | string,
    displayType?: any,
    thousandSeparator?: boolean,
    prefix?: string
};

const Number: React.FC<NumberProps> = ({ value, displayType, thousandSeparator, prefix }) => {
    return (<NumericFormat
        value={value}
        displayType={displayType || 'text'}
        allowNegative={true}
        thousandSeparator={thousandSeparator || true}
        prefix={prefix || ''}
    />);
};

export default Number;